import { BadgeList } from '~/components/BadgeList/BadgeList';
import { CompetitionBadge } from './competition-badge';
import { Badge } from '~/components/Badge/Badge';
import { CompetitionList } from '~/apis/ssf';
import { match } from 'ts-pattern';

interface Props {
  competition: Pick<
    CompetitionList,
    'state' | 'registration_open' | 'open_externally' | 'registrations_limit' | 'registrations_count' | 'is_team_comp'
  >;
  inline?: boolean;
}

export function CompetitionBadges({ competition, inline }: Props) {
  const shouldShowOpenExternally = match(competition)
    .with({ open_externally: true, registration_open: true }, () => true)
    .otherwise(() => false);

  return (
    <BadgeList inline={inline}>
      <CompetitionBadge competition={competition} />
      {competition.is_team_comp && <Badge variant="default" label="Lagtävling" />}
      {shouldShowOpenExternally && <Badge variant="default" label="Öppen för externa lyftare" />}
    </BadgeList>
  );
}
